import React, { useId } from 'react';

const SIGNATURE_METHOD_MOBILE = 'mobile';
const SIGNATURE_METHOD_PAPER = 'paper';

const GROUP_LABEL = '¿Cómo firmará el cliente?';

const METHODS = [
  {
    id: SIGNATURE_METHOD_MOBILE,
    icon: 'bi-phone',
    title: 'Firma digital',
    description: 'El cliente revisa y firma el contrato desde un dispositivo.',
    badge: 'Recomendada'
  },
  {
    id: SIGNATURE_METHOD_PAPER,
    icon: 'bi-file-earmark-arrow-up',
    title: 'Firma manual',
    description: 'El cliente firma el contrato en papel y luego se carga la documentación.',
    badge: 'Alternativa'
  }
];

const SignatureMethodSelector = ({
  selectedMethod = '',
  onSelectMethod,
  isDigitalSignatureAvailable = true,
  isPersistingSelection = false,
  groupLabelId = '',
  digitalUnavailableMessage = 'La firma digital no está disponible hasta que el contrato se cargue correctamente.'
}) => {
  const baseId = useId();
  const digitalUnavailableId = `${baseId}-digital-unavailable`;

  const handleSelectMethod = (event) => {
    if (event.target.disabled || isPersistingSelection) {
      return;
    }

    const nextMethod = event.target.value;
    if (nextMethod === selectedMethod) {
      return;
    }

    onSelectMethod?.(nextMethod);
  };

  return (
    <>
      {isPersistingSelection && (
        <p className="rg-signature-method-selector__persisting" role="status">
          Guardando modalidad de firma...
        </p>
      )}

      <fieldset
        className="rg-signature-method-selector"
        aria-labelledby={groupLabelId || undefined}
        disabled={isPersistingSelection || undefined}
      >
        {!groupLabelId && (
          <legend className="rg-signature-method-selector__legend">
            {GROUP_LABEL}
          </legend>
        )}

        <div className="rg-signature-method-selector__grid">
          {METHODS.map((method) => {
            const isSelected = selectedMethod === method.id;
            const isDigitalMethod = method.id === SIGNATURE_METHOD_MOBILE;
            const isDisabled = isPersistingSelection
              || (isDigitalMethod && !isDigitalSignatureAvailable);
            const descriptionId = `${baseId}-${method.id}-description`;
            const describedBy = isDigitalMethod && !isDigitalSignatureAvailable
              ? `${descriptionId} ${digitalUnavailableId}`
              : descriptionId;

            return (
              <label
                key={method.id}
                className={[
                  'rg-signature-method-card',
                  isSelected ? 'rg-signature-method-card--selected' : '',
                  isDisabled ? 'rg-signature-method-card--disabled' : ''
                ].filter(Boolean).join(' ')}
              >
                <input
                  type="radio"
                  name="signature-method"
                  value={method.id}
                  checked={isSelected}
                  disabled={isDisabled}
                  onChange={handleSelectMethod}
                  aria-describedby={describedBy}
                  className="visually-hidden rg-signature-method-card__input"
                />

                <div className="rg-signature-method-card__header">
                  <span className="rg-signature-method-card__icon" aria-hidden="true">
                    <i className={`bi ${method.icon}`}></i>
                  </span>
                  <span className="rg-signature-method-card__badge" aria-hidden="true">{method.badge}</span>
                </div>

                <div className="rg-signature-method-card__body">
                  <span className="rg-signature-method-card__title">{method.title}</span>
                  <span
                    id={descriptionId}
                    className="rg-signature-method-card__description"
                  >
                    {method.description}
                  </span>
                </div>

                {isSelected && (
                  <span className="rg-signature-method-card__check" aria-hidden="true">
                    <i className="bi bi-check-lg"></i>
                  </span>
                )}
              </label>
            );
          })}
        </div>
      </fieldset>

      {!isDigitalSignatureAvailable && (
        <p
          id={digitalUnavailableId}
          className="rg-signature-method-selector__availability"
        >
          {digitalUnavailableMessage}
        </p>
      )}
    </>
  );
};

export { SIGNATURE_METHOD_MOBILE, SIGNATURE_METHOD_PAPER };
export default SignatureMethodSelector;
